<template>
    <div class="body">
        <v-snackbar
                v-model="snackbar"
                bottom
                color="success"
                style="direction: rtl; text-align: center"
                :timeout="1500"
        >
            {{ message }}
        </v-snackbar>

        <DataTable
                :url="url"
                :titles="titles"
                :formatter="formatter"
                :fields-hidden-add="['id' , 'created_at', 'updated_at','referral_code']"
                :fields-hidden-main="['updated_at']"
                :enableEdit="false"
                :disableSearch="true"
                :actions-extra-main="actionsExtraMain"
        />


    </div>

</template>

<script>
    import DataTable from "@/components/wasilni/DataTable";

    export default {
        name: "AdvertisingCampaign",
        title: "Advertising Campaign",
        components: {DataTable},
        data() {
            return {
                snackbar: false,
                message: "",
                valid: true,
                lazy: false,
                loading: false,
                url: "advertisement",
            }
        },
        computed: {
            titles() {
                return {
                    id: '#',
                    name: 'Name',
                    details: 'Details',
                    referral_code: 'Referral Code',
                    created_at: "Created At",
                }
            },
            formatter() {
                return {
                    referral_code: (value) => "https://www.wasilni.com/captain#/?referral_code=" + value.code
                }
            },
            actionsExtraMain() {
                return {
                    copyText: {
                        title: "Profile",
                        icon: 'content_copy',
                        action: (item) =>
                        {
                            let textToCopy = "https://www.wasilni.com/captain#/?referral_code="+item.referral_code.code;
                            // console.log(textToCopy);
                            var input = document.createElement('input');
                            input.value = textToCopy;
                            document.body.appendChild(input);
                            input.select();
                            document.execCommand("copy");
                            document.body.removeChild(input);
                            this.snackbar = true;
                            this.message = 'Copied to clipboard';
                        }
                    }
                }
            }
        },

    }
</script>

<style scoped>

</style>
